import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import {
  DeviceFirstPage,
  ScanDevice,
  AllDevice,
  DeviceInfo,
  EndPage,
  WidgetsJoined,
} from "./";
import { DeviceSection } from "../../context/DeviceContext";
import { FiCpu, FiPlus, FiCheckCircle, FiInfo, FiGrid, FiArrowLeft } from "react-icons/fi";

const DeviceOrg = () => {
  const { t } = useTranslation();
  const { devicePage } = useContext(DeviceSection);

  // تعیین عنوان بر اساس صفحه فعلی
  const getTitle = () => {
    if (devicePage.firstPage) return t("اضافه کردن دستگاه");
    if (devicePage.scanDevice) return t("اسکن دستگاه");
    if (devicePage.allDevices) return t("لیست ویجت ها");
    if (devicePage.deviceInfo) return t("اطلاعات دستگاه");
    if (devicePage.widgetsJoined) return t("ویجت‌ های متصل");
    if (devicePage.endPage) return t("اضافه شدن دستگاه");
    return t("اضافه کردن دستگاه");
  };

  // تعیین آیکون بر اساس صفحه فعلی
  const getIcon = () => {
    if (devicePage.firstPage) return <FiPlus size={24} />;
    if (devicePage.scanDevice) return <FiGrid size={24} />;
    if (devicePage.allDevices) return <FiCpu size={24} />;
    if (devicePage.deviceInfo) return <FiInfo size={24} />;
    if (devicePage.widgetsJoined) return <FiCheckCircle size={24} />;
    if (devicePage.endPage) return <FiCheckCircle size={24} />;
    return <FiPlus size={24} />;
  };

  return (
    <div className="setting-container" style={{ minHeight: "auto", padding: "24px" }}>
      {/* Header with Icon and Title */}
      <div className="device-org-header">
        <div className="device-org-icon">
          {getIcon()}
        </div>
        <h2 className="setting-title" style={{ marginBottom: 0, flex: 1 }}>
          {getTitle()}
        </h2>
      </div>

      {/* Content */}
      <div className="device-org-content">
        {devicePage.firstPage && <DeviceFirstPage />}
        {devicePage.scanDevice && <ScanDevice />}
        {devicePage.allDevices && <AllDevice />}
        {devicePage.deviceInfo && <DeviceInfo />}
        {devicePage.widgetsJoined && <WidgetsJoined />}
        {devicePage.endPage && <EndPage />}
      </div>
    </div>
  );
};

export { DeviceOrg };